import React, {useState, useEffect, useCallback} from 'react'
import './Calendar.css';
import {CreateButton} from '../components/CommonObjects';
import {SetAuditTrail, SetAuditTrailBulk} from './Reports/AuditTrailReportEmployeeSetup';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import en from 'date-fns/locale/en-US';
import {token, domain} from './Security';
import axios from 'axios';
import loadingSpinner from './../assets/loading.gif';
import {useTable, useSortBy} from 'react-table';
// icons
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import CalendarViewDayIcon from '@mui/icons-material/CalendarViewDay';

registerLocale('en', en);

function Calendar({user, userAccess, isHideSideMenu}) {
    // const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [description, setDescription] = useState("");
    const [date, setDate] = useState("");
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [contentAnnouncement, setContentAnnouncement] = useState("");
    const [contentMemo, setContentMemo] = useState("");
    const [filesAnnouncement, setFilesAnnouncement] = useState("");
    const [filesMemo, setFilesMemo] = useState("");

    //old
    const [oldDescription, setOldDescription] = useState("");
    const [oldDateFrom, setOldDateFrom] = useState("");
    const [oldDateTo, setOldDateTo] = useState("");
    const [oldContentAnnouncement, setOldContentAnnouncement] = useState("");
    const [oldContentMemo, setOldContentMemo] = useState("");
    const [oldFilesAnnouncement, setOldFilesAnnouncement] = useState("");
    const [oldFilesMemo, setOldFilesMemo] = useState("");

    const [editDataAnnouncement, setEditDataAnnouncement] = useState([]);
    const [editDataMemo, setEditDataMemo] = useState([]);
    const [generalData, setGeneralData] = useState([]);
    const [eventDate, setEventDate] = useState("");
    //edit
    const [showEditAnnouncement, setShowEditAnnouncement] = useState(false);
    const [showEditMemo, setShowEditMemo] = useState(false);
    const [isUpdateAnnouncement, setIsUpdateAnnouncement] = useState(false);
    const [isRefreshEvents, setIsRefreshEvents] = useState(false);
    //delete
    const [showDeleteAnnouncement, setShowDeleteAnnouncement] = useState(false);
    const [showDeleteMemo, setShowDeleteMemo] = useState(false);
    const [isUpdateMemo, setIsUpdateMemo] = useState(false);
    //general announcement
    const [descriptionGeneralAnnouncement, setDescriptionGeneralAnnouncement] = useState("");
    const [contentGeneralAnnouncement, setContentGeneralAnnouncement] = useState("");
    const [filesGeneralAnnouncement, setFilesGeneralAnnouncement] = useState("");
    //old
    const [oldDescriptionGeneralAnnouncement, setOldDescriptionGeneralAnnouncement] = useState("");
    const [oldContentGeneralAnnouncement, setOldContentGeneralAnnouncement] = useState("");
    const [oldFilesGeneralAnnouncement, setOldFilesGeneralAnnouncement] = useState("");
    //general memo
    const [descriptionGeneralMemo, setDescriptionGeneralMemo] = useState("");
    const [contentGeneralMemo, setContentGeneralMemo] = useState("");
    const [filesGeneralMemo, setFilesGeneralMemo] = useState("");
    //old
    const [oldDescriptionGeneralMemo, setOldDescriptionGeneralMemo] = useState("");
    const [oldContentGeneralMemo, setOldContentGeneralMemo] = useState("");
    const [oldFilesGeneralMemo, setOldFilesGeneralMemo] = useState("");

    const [showAnnouncementForm, setShowAnnouncementForm] = useState(false);
    const [showMemoForm, setShowMemoForm] = useState(false);
    const [showGeneralAnnouncementForm, setShowGeneralAnnouncementForm] = useState(false);
    const [showGeneralMemoForm, setShowGeneralMemoForm] = useState(false);

    const [showEventsAnnouncement, setShowEventsAnnouncement] = useState(false);
    const [showEventsMemo, setShowEventsMemo] = useState(false);
    const [showAllEventsAnnouncement, setShowAllEventsAnnouncement] = useState(false);
    const [showAllEventsMemo, setShowAllEventsMemo] = useState(false);

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const handleSubmitGeneralAnnouncementCreate = async (event) => {
        event.preventDefault();
        const apiUrl =  domain + "/api/General";

        const toBase64 = (file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    
        let base64String = "";
        let photoToBeSave = "";
    
        if(filesGeneralAnnouncement.length > 0){
            base64String = await toBase64(filesGeneralAnnouncement[0]);
            photoToBeSave = base64String.split(',')[1];
        }

        const data = {
            key: "Announcement",
            title: descriptionGeneralAnnouncement,
            description: contentGeneralAnnouncement,
            content: filesGeneralAnnouncement ? photoToBeSave : null,
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setShowGeneralAnnouncementForm(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Calendar", 
                actionTaken: "insert", 
                field: "Add", 
                newValue: `${data.title}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            setShowRequestMessage(true);
            setIsSuccess(true);

            setDescriptionGeneralAnnouncement("");
            setContentGeneralAnnouncement("");
            setFilesGeneralAnnouncement("");
            
            // Reload table data and reset form fields
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowGeneralAnnouncementForm(false);
    };
    const handleSubmitGeneralAnnouncementUpdate = async (event) => {
        event.preventDefault();
        const apiUrl =  domain + "/api/General";

        const toBase64 = (file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    
        let base64String = "";
        let photoToBeSave = "";
    
        if(filesGeneralAnnouncement.length > 0){
            base64String = await toBase64(filesGeneralAnnouncement[0]);
            photoToBeSave = base64String.split(',')[1];
        }

        const data = {
            key: "Announcement",
            title: descriptionGeneralAnnouncement,
            description: contentGeneralAnnouncement,
            content: filesGeneralAnnouncement ? photoToBeSave : null,
        };

        try {
            setLoadingRequest(true);
            await axios.put(`${apiUrl}/${generalData.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            let auditInfo = [];

            if(data.title !== oldDescriptionGeneralAnnouncement){
                auditInfo.push({
                    setupArea: "Calendar",
                    actionTaken: "update",
                    field: "Description",
                    newValue: `${data.title}`,
                    oldValue: `${oldDescriptionGeneralAnnouncement}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.description !== oldContentGeneralAnnouncement){
                auditInfo.push({
                    setupArea: "Calendar",
                    actionTaken: "update",
                    field: "Content",
                    newValue: `${data.description}`,
                    oldValue: `${oldContentGeneralAnnouncement}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(filesGeneralAnnouncement !== oldFilesGeneralAnnouncement){
                auditInfo.push({
                    setupArea: "Calendar",
                    actionTaken: "update",
                    field: "Image",
                    newValue: `-`,
                    oldValue: `-`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            setShowGeneralAnnouncementForm(false); // Hide the add form
            await SetAuditTrailBulk({data: auditInfo});

            setShowRequestMessage(true);
            setIsSuccess(true);

            setDescriptionGeneralAnnouncement("");
            setContentGeneralAnnouncement("");
            setFilesGeneralAnnouncement("");
            setGeneralData([]);
            
            // Reload table data and reset form fields
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowGeneralAnnouncementForm(false);
    };
    const handleSubmitGeneralDelete = async (event) => {
        event.preventDefault();
        const apiUrl =  domain + "/api/General";

        if(generalData === "" || generalData === null || generalData === undefined || generalData.length <= 0){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Nothing to clear!");
            return;
        }

        try {
            setLoadingRequest(true);
            await axios.delete(`${apiUrl}/${generalData.id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            await SetAuditTrail({
                setupArea: "Calendar", 
                actionTaken: "delete", 
                field: "Clear Announcement/ Memo", 
                newValue: `-`, 
                oldValue: `${generalData.title}`, 
                dateSaved: new Date(), 
                savedById: user.id
            });

            setShowRequestMessage(true);
            setIsSuccess(true);
            
            setDescriptionGeneralAnnouncement("");
            setContentGeneralAnnouncement("");
            setFilesGeneralAnnouncement("");
            
            setDescriptionGeneralMemo("");
            setContentGeneralMemo("");
            setFilesGeneralMemo("");
            setGeneralData([]);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const handleSubmitGeneralMemoCreate = async (event) => {
        event.preventDefault();
        const apiUrl =  domain + "/api/General";

        const toBase64 = (file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    
        let base64String = "";
        let photoToBeSave = "";
    
        if(filesGeneralMemo.length > 0){
            base64String = await toBase64(filesGeneralMemo[0]);
            photoToBeSave = base64String.split(',')[1];
        }

        const data = {
            key: "Memo",
            title: descriptionGeneralMemo,
            description: contentGeneralMemo,
            content: filesGeneralMemo ? photoToBeSave : null,
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowGeneralMemoForm(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Calendar", 
                actionTaken: "insert", 
                field: "Add", 
                newValue: `${data.title}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            setShowRequestMessage(true);
            setIsSuccess(true);

            setDescriptionGeneralMemo("");
            setContentGeneralMemo("");
            setFilesGeneralMemo("");
            
            // Reload table data and reset form fields
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowGeneralMemoForm(false);
    };
    const handleSubmitGeneralMemoUpdate = async (event) => {
        event.preventDefault();
        const apiUrl =  domain + "/api/General";

        const toBase64 = (file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    
        let base64String = "";
        let photoToBeSave = "";
    
        if(filesGeneralMemo.length > 0){
            base64String = await toBase64(filesGeneralMemo[0]);
            photoToBeSave = base64String.split(',')[1];
        }

        const data = {
            key: "Memo",
            title: descriptionGeneralMemo,
            description: contentGeneralMemo,
            content: filesGeneralMemo ? photoToBeSave : null,
        };

        try {
            setLoadingRequest(true);
            await axios.put(`${apiUrl}/${generalData.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            let auditInfo = [];

            if(data.title !== oldDescriptionGeneralMemo){
                auditInfo.push({
                    setupArea: "Calendar",
                    actionTaken: "update",
                    field: "Description",
                    newValue: `${data.title}`,
                    oldValue: `${oldDescriptionGeneralMemo}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.description !== oldContentGeneralMemo){
                auditInfo.push({
                    setupArea: "Calendar",
                    actionTaken: "update",
                    field: "Content",
                    newValue: `${data.description}`,
                    oldValue: `${oldContentGeneralMemo}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(filesGeneralMemo !== oldFilesGeneralMemo){
                auditInfo.push({
                    setupArea: "Calendar",
                    actionTaken: "update",
                    field: "Image",
                    newValue: `-`,
                    oldValue: `-`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            setShowGeneralMemoForm(false); // Hide the add form
            await SetAuditTrailBulk({data: auditInfo});

            setShowRequestMessage(true);
            setIsSuccess(true);

            setDescriptionGeneralMemo("");
            setContentGeneralMemo("");
            setFilesGeneralMemo("");
            setGeneralData([]);
            
            // Reload table data and reset form fields
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowGeneralMemoForm(false);
    };
    const handleSubmitAnnouncement = async (event) => {
        event.preventDefault();
        const apiUrl =  domain + "/api/Announcement";

        const toBase64 = (file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    
        let base64String = "";
        let photoToBeSave = "";
    
        if(filesAnnouncement.length > 0){
            base64String = await toBase64(filesAnnouncement[0]);
            photoToBeSave = base64String.split(',')[1];
        }

        const data = {
            title: description,
            dateFrom: dateFrom,
            dateTo: dateTo,
            description: contentAnnouncement,
            content: filesAnnouncement ? photoToBeSave : null,
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setShowAnnouncementForm(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Calendar", 
                actionTaken: "insert", 
                field: "Add", 
                newValue: `${data.title}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setDescription("");
            setDate("");
            setContentAnnouncement("");
            setFilesAnnouncement("");
            setIsRefreshEvents(true);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAnnouncementForm(false);
    };
    const handleUpdateAnnouncement = async (event) => {
        event.preventDefault();
        const apiUrl =  domain + "/api/Announcement";

        const toBase64 = (file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    
        let base64String = "";
        let photoToBeSave = "";
    
        if(filesAnnouncement.length > 0){
            base64String = await toBase64(filesAnnouncement[0]);
            photoToBeSave = base64String.split(',')[1];
        }

        const data = {
            title: description,
            dateFrom: dateFrom,
            dateTo: dateTo,
            description: contentAnnouncement,
            content: filesAnnouncement ? photoToBeSave : null,
        };

        try {
            setLoadingRequest(true);
            await axios.put(`${apiUrl}/${editDataAnnouncement.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            let auditInfo = [];

            if(data.title !== oldDescription){
                auditInfo.push({
                    setupArea: "Calendar",
                    actionTaken: "update",
                    field: "Description",
                    newValue: `${data.title}`,
                    oldValue: `${oldDescription}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.dateFrom !== oldDateFrom){
                auditInfo.push({
                    setupArea: "Calendar",
                    actionTaken: "update",
                    field: "Date From",
                    newValue: `${data.dateFrom}`,
                    oldValue: `${oldDateFrom}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.dateTo !== oldDateTo){
                auditInfo.push({
                    setupArea: "Calendar",
                    actionTaken: "update",
                    field: "Date To",
                    newValue: `${data.dateTo}`,
                    oldValue: `${oldDateTo}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.description !== oldContentAnnouncement){
                auditInfo.push({
                    setupArea: "Calendar",
                    actionTaken: "update",
                    field: "Content",
                    newValue: `${data.description}`,
                    oldValue: `${oldContentAnnouncement}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(filesAnnouncement !== oldFilesAnnouncement){
                auditInfo.push({
                    setupArea: "Calendar",
                    actionTaken: "update",
                    field: "Image",
                    newValue: `-`,
                    oldValue: `-`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            setShowEditAnnouncement(false); // Hide the add form
            await SetAuditTrailBulk({data: auditInfo});

            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setDescription("");
            setDate("");
            setContentAnnouncement("");
            setFilesAnnouncement("");
            setIsUpdateAnnouncement(true);
            setIsRefreshEvents(true);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditAnnouncement(false);
    };
    const handleDeleteAnnouncement = async (event) => {
        event.preventDefault();
        const apiUrl =  domain + "/api/Announcement";

        try {
            setLoadingRequest(true);
            await axios.delete(`${apiUrl}/${editDataAnnouncement.id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setShowDeleteAnnouncement(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Calendar", 
                actionTaken: "delete", 
                field: "Delete", 
                newValue: `-`, 
                oldValue: `${editDataAnnouncement.title}`, 
                dateSaved: new Date(), 
                savedById: user.id
            });
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setDescription("");
            setDateFrom("");
            setDateTo("");
            setContentAnnouncement("");
            setFilesAnnouncement("");
            setIsUpdateAnnouncement(true);
            setIsRefreshEvents(true);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowDeleteAnnouncement(false);
    };
    const handleSubmitMemo = async (event) => {
        event.preventDefault();
        const apiUrl =  domain + "/api/Memo";

        const toBase64 = (file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    
        let base64String = "";
        let photoToBeSave = "";
    
        if(filesMemo.length > 0){
            base64String = await toBase64(filesMemo[0]);
            photoToBeSave = base64String.split(',')[1];
        }

        const data = {
            title: description,
            dateFrom: dateFrom,
            dateTo: dateTo,
            description: contentMemo,
            content: filesMemo ? photoToBeSave : null,
        };

        console.log('Final bulkData:', JSON.stringify(data, null, 2));

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowMemoForm(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Calendar", 
                actionTaken: "insert", 
                field: "Add", 
                newValue: `${data.title}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setDescription("");
            setContentMemo("");
            setDate("");
            setFilesMemo("");
            setIsRefreshEvents(true);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowMemoForm(false);
    };
    const handleUpdateMemo = async (event) => {
        event.preventDefault();
        const apiUrl =  domain + "/api/Memo";

        const toBase64 = (file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    
        let base64String = "";
        let photoToBeSave = "";
    
        if(filesMemo.length > 0){
            base64String = await toBase64(filesMemo[0]);
            photoToBeSave = base64String.split(',')[1];
        }

        const data = {
            title: description,
            dateFrom: dateFrom,
            dateTo: dateTo,
            description: contentMemo,
            content: filesMemo ? photoToBeSave : null,
        };

        console.log('Final bulkData:', JSON.stringify(data, null, 2));

        try {
            setLoadingRequest(true);
            await axios.put(`${apiUrl}/${editDataMemo.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            let auditInfo = [];

            if(data.title !== oldDescription){
                auditInfo.push({
                    setupArea: "Calendar",
                    actionTaken: "update",
                    field: "Description",
                    newValue: `${data.title}`,
                    oldValue: `${oldDescription}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.dateFrom !== oldDateFrom){
                auditInfo.push({
                    setupArea: "Calendar",
                    actionTaken: "update",
                    field: "Date From",
                    newValue: `${data.dateFrom}`,
                    oldValue: `${oldDateFrom}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.dateTo !== oldDateTo){
                auditInfo.push({
                    setupArea: "Calendar",
                    actionTaken: "update",
                    field: "Date To",
                    newValue: `${data.dateTo}`,
                    oldValue: `${oldDateTo}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.description !== oldContentMemo){
                auditInfo.push({
                    setupArea: "Calendar",
                    actionTaken: "update",
                    field: "Content",
                    newValue: `${data.description}`,
                    oldValue: `${oldContentMemo}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(filesMemo !== oldFilesMemo){
                auditInfo.push({
                    setupArea: "Calendar",
                    actionTaken: "update",
                    field: "Image",
                    newValue: `-`,
                    oldValue: `-`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            setShowEditMemo(false); // Hide the add form
            await SetAuditTrailBulk({data: auditInfo});

            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setDescription("");
            setContentMemo("");
            setDate("");
            setFilesMemo("");
            setIsUpdateMemo(true); // Hide the add form
            setIsRefreshEvents(true);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditMemo(false);
    };
    const handleDeleteMemo = async (event) => {
        event.preventDefault();
        const apiUrl =  domain + "/api/Memo";

        try {
            setLoadingRequest(true);
            await axios.delete(`${apiUrl}/${editDataMemo.id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setShowDeleteMemo(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Calendar", 
                actionTaken: "delete", 
                field: "Delete", 
                newValue: `-`, 
                oldValue: `${editDataMemo.title}`, 
                dateSaved: new Date(), 
                savedById: user.id
            });

            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setDescription("");
            setContentMemo("");
            setDateFrom("");
            setDateTo("");
            setFilesMemo("");
            setIsUpdateMemo(true); // Hide the add form
            setIsRefreshEvents(true);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowDeleteMemo(false);
    };

    const todayHandlerClick = () => {
        setSelectedDate(new Date());
    };
    const previousHandlerClick = () => {
        const newDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth() - 1, 1);
        setSelectedDate(newDate);
    };
    const nextHandlerClick = () => {
        const newDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 1);
        setSelectedDate(newDate);
    };
    const addAnnouncementHandlerClick = () => {
        setShowAnnouncementForm(true);
    };
    const closeAnnouncementFormHandlerClick = () =>{
        setShowAnnouncementForm(false);
    }
    const addMemoHandlerClick = () => {
        setShowMemoForm(true);
    };
    const closeMemoFormHandlerClick = () =>{
        setShowMemoForm(false);
    }
    const addGeneralAnnouncementHandlerClick = () => {
        setShowGeneralAnnouncementForm(true);
    };
    const closeGeneralAnnouncementFormHandlerClick = () =>{
        setShowGeneralAnnouncementForm(false);
    }
    const addGeneralMemoHandlerClick = () => {
        setShowGeneralMemoForm(true);
    };
    const closeGeneralMemoFormHandlerClick = () =>{
        setShowGeneralMemoForm(false);
    }
    const addEventsAnnouncementHandlerClick = (date) => {
        setEventDate(date);
        setShowEventsAnnouncement(true);
    };
    const closeEventsAnnouncementHandlerClick = () =>{
        setEventDate("");
        setShowEventsAnnouncement(false);
    }
    const addEventsMemoHandlerClick = (date) => {
        setEventDate(date);
        setShowEventsMemo(true);
    };
    const closeEventsMemoHandlerClick = () =>{
        setEventDate("");
        setShowEventsMemo(false);
    }
    const addAllEventsAnnouncementHandlerClick = () => {
        setShowAllEventsAnnouncement(true);
    };
    const closeAllEventsAnnouncementHandlerClick = () =>{
        setShowAllEventsAnnouncement(false);
    }
    const addAllEventsMemoHandlerClick = () => {
        setShowAllEventsMemo(true);
    };
    const closeAllEventsMemoHandlerClick = () =>{
        setShowAllEventsMemo(false);
    }

    //edit announcement
    const editHandleClickAnnouncement = (data) => {
        setEditDataAnnouncement(data);
        setShowEditAnnouncement(true);
    };
    const closeEditAnnouncementFormHandlerClick = () => {
        setShowEditAnnouncement(false);
        setDescription("");
        setDateFrom("");
        setDateTo("");
        setContentAnnouncement("");
        setFilesAnnouncement([]);
        setEditDataAnnouncement([]);
    };
    useEffect(() => {
        if(showEditAnnouncement){
            let filesToBeSet = [];

            setDescription(editDataAnnouncement.title);
            setDateFrom(editDataAnnouncement.dateFrom);
            setDateTo(editDataAnnouncement.dateTo);
            setContentAnnouncement(editDataAnnouncement.description);

            setOldDescription(editDataAnnouncement.title);
            setOldDateFrom(editDataAnnouncement.dateFrom);
            setOldDateTo(editDataAnnouncement.dateTo);
            setOldContentAnnouncement(editDataAnnouncement.description);

            if(editDataAnnouncement.content){
                const binaryData = atob(editDataAnnouncement.content);
        
                // Convert the binary data to a Uint8Array
                const arrayBuffer = new ArrayBuffer(binaryData.length);
                const uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < binaryData.length; i++) {
                    uint8Array[i] = binaryData.charCodeAt(i);
                }
        
                const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data
        
                const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type
        
                filesToBeSet.push(file);
            }

            setFilesAnnouncement(filesToBeSet);
            setOldFilesAnnouncement(filesToBeSet);
        }
    }, [showEditAnnouncement, editDataAnnouncement]);
    //delete announcement
    const deleteHandleClickAnnouncement = (data) => {
        setEditDataAnnouncement(data);
        setShowDeleteAnnouncement(true);
    };
    const closeDeleteAnnouncementFormHandlerClick = () => {
        setShowDeleteAnnouncement(false);
        setDescription("");
        setDate("");
        setContentAnnouncement("");
        setFilesAnnouncement([]);
        setEditDataAnnouncement([]);
    };

    //edit memo
    const editHandleClickMemo = (data) => {
        setEditDataMemo(data);
        setShowEditMemo(true);
    };
    const closeEditMemoFormHandlerClick = () => {
        setShowEditMemo(false);
        setDescription("");
        setDate("");
        setContentMemo("");
        setFilesMemo([]);
        setEditDataMemo([]);
    };
    useEffect(() => {
        if(showEditMemo){
            let filesToBeSet = [];

            setDescription(editDataMemo.title);
            setDateFrom(editDataMemo.dateFrom);
            setDateTo(editDataMemo.dateTo);
            setContentMemo(editDataMemo.description);

            setOldDescription(editDataMemo.title);
            setOldDateFrom(editDataMemo.dateFrom);
            setOldDateTo(editDataMemo.dateTo);
            setOldContentMemo(editDataMemo.description);

            if(editDataMemo.content){
                const binaryData = atob(editDataMemo.content);
        
                // Convert the binary data to a Uint8Array
                const arrayBuffer = new ArrayBuffer(binaryData.length);
                const uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < binaryData.length; i++) {
                    uint8Array[i] = binaryData.charCodeAt(i);
                }
        
                const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data
        
                const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type
        
                filesToBeSet.push(file);
            }

            setFilesMemo(filesToBeSet);
            setOldFilesMemo(filesToBeSet);

        }
    }, [showEditMemo, editDataMemo]);
    //delete memo
    const deleteHandleClickMemo = (data) => {
        setEditDataMemo(data);
        setShowDeleteMemo(true);
    };
    const closeDeleteMemoFormHandlerClick = () => {
        setShowDeleteMemo(false);
        setDescription("");
        setDate("");
        setContentMemo("");
        setFilesMemo([]);
        setEditDataMemo([]);
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                <div className="ReportsInfo">
                    <div className="reports-header">
                        <h3>Scheduler Page</h3>
                    </div>
                    <div className="reports-body">
                        <CalendarHeader todayHandlerClick={todayHandlerClick}
                        previousHandlerClick={previousHandlerClick}
                        nextHandlerClick={nextHandlerClick}
                        addAnnouncementHandlerClick={addAnnouncementHandlerClick}
                        addGeneralAnnouncementHandlerClick={addGeneralAnnouncementHandlerClick}
                        addMemoHandlerClick={addMemoHandlerClick}
                        addGeneralMemoHandlerClick={addGeneralMemoHandlerClick}
                        userAccess={userAccess}
                        />
                        <div className='date-today row' style={{alignItems: "center"}}>
                            <MonthYearPicker selectedDate={selectedDate} setSelectedDate={setSelectedDate}/>
                            <div className="calendar-buttons cmdButton row">
                                <div className="calendar-button row" style={{marginRight:"5px"}}>
                                    {CreateButton("", "command viewAll row", addAllEventsAnnouncementHandlerClick, "VIEW ALL ANNOUNCEMENT", RemoveRedEyeIcon)}
                                </div>
                                <div className="calendar-button row">
                                    {CreateButton("", "command viewAll row", addAllEventsMemoHandlerClick, "VIEW ALL MEMO", RemoveRedEyeIcon)}
                                </div>
                            </div>
                        </div>
                        <CalendarBody   selectedDate={selectedDate} 
                                        date={date}
                                        setDate={setDate}
                                        addEventsAnnouncementHandlerClick={addEventsAnnouncementHandlerClick}
                                        addEventsMemoHandlerClick={addEventsMemoHandlerClick}
                                        isRefreshEvents={isRefreshEvents}
                                        setIsRefreshEvents={setIsRefreshEvents}
                                        userAccess={userAccess}
                        />
                    </div>
                    <div className="reports-footer">
                    </div>
                </div>
                </div>
            </div>
            <AddAnnouncementForm  isOpen={showAnnouncementForm} 
                    onClose={closeAnnouncementFormHandlerClick}
                    description={description}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    contentAnnouncement={contentAnnouncement}
                    files={filesAnnouncement}
                    setDescription={setDescription}
                    setDateFrom={setDateFrom}
                    setDateTo={setDateTo}
                    setContentAnnouncement={setContentAnnouncement}
                    setFiles={setFilesAnnouncement}
                    handleSubmitAnnouncement={handleSubmitAnnouncement}
                    userAccess={userAccess}
            >
            </AddAnnouncementForm>
            <AddMemoForm  isOpen={showMemoForm} 
                    onClose={closeMemoFormHandlerClick}
                    description={description}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    contentMemo={contentMemo}
                    files={filesMemo}
                    setDescription={setDescription}
                    setDateFrom={setDateFrom}
                    setDateTo={setDateTo}
                    setContentMemo={setContentMemo}
                    setFiles={setFilesMemo}
                    handleSubmitMemo={handleSubmitMemo}
                    userAccess={userAccess}
            >
            </AddMemoForm>
            <AddGeneralAnnouncementForm  isOpen={showGeneralAnnouncementForm} 
                    onClose={closeGeneralAnnouncementFormHandlerClick}
                    description={descriptionGeneralAnnouncement}
                    date={date}
                    contentAnnouncement={contentGeneralAnnouncement}
                    files={filesGeneralAnnouncement}
                    setDescription={setDescriptionGeneralAnnouncement}
                    setDate={setDate}
                    setContentAnnouncement={setContentGeneralAnnouncement}
                    setFiles={setFilesGeneralAnnouncement}
                    setOldDescription={setOldDescriptionGeneralAnnouncement}
                    setOldContentAnnouncement={setOldContentGeneralAnnouncement}
                    setOldFiles={setOldFilesGeneralAnnouncement}
                    setGeneralData={setGeneralData}
                    handleSubmitAnnouncementCreate={handleSubmitGeneralAnnouncementCreate}
                    handleSubmitAnnouncementUpdate={handleSubmitGeneralAnnouncementUpdate}
                    handleSubmitGeneralDelete={handleSubmitGeneralDelete}
                    userAccess={userAccess}
            >
            </AddGeneralAnnouncementForm>
            <AddGeneralMemoForm  isOpen={showGeneralMemoForm} 
                    onClose={closeGeneralMemoFormHandlerClick}
                    description={descriptionGeneralMemo}
                    date={date}
                    contentMemo={contentGeneralMemo}
                    files={filesGeneralMemo}
                    setDescription={setDescriptionGeneralMemo}
                    setDate={setDate}
                    setContentMemo={setContentGeneralMemo}
                    setFiles={setFilesGeneralMemo}
                    setOldDescription={setOldDescriptionGeneralMemo}
                    setOldContentMemo={setOldContentGeneralMemo}
                    setOldFiles={setOldFilesGeneralMemo}
                    setGeneralData={setGeneralData}
                    handleSubmitMemoCreate={handleSubmitGeneralMemoCreate}
                    handleSubmitMemoUpdate={handleSubmitGeneralMemoUpdate}
                    handleSubmitGeneralDelete={handleSubmitGeneralDelete}
                    userAccess={userAccess}
            >
            </AddGeneralMemoForm>
            <ViewEventsAnnouncementForm  isOpen={showEventsAnnouncement} 
                    onClose={closeEventsAnnouncementHandlerClick}
                    eventDate={eventDate}
                    editHandleClick={editHandleClickAnnouncement}
                    deleteHandleClick={deleteHandleClickAnnouncement}
                    isUpdate={isUpdateAnnouncement}
                    setIsUpdate={setIsUpdateAnnouncement}
                    userAccess={userAccess}
            >
            </ViewEventsAnnouncementForm>
            <ViewEventsMemoForm  isOpen={showEventsMemo} 
                    onClose={closeEventsMemoHandlerClick}
                    eventDate={eventDate}
                    editHandleClick={editHandleClickMemo}
                    deleteHandleClick={deleteHandleClickMemo}
                    isUpdate={isUpdateMemo}
                    setIsUpdate={setIsUpdateMemo}
                    userAccess={userAccess}
            >
            </ViewEventsMemoForm>
            <ViewAllEventsAnnouncementForm  isOpen={showAllEventsAnnouncement} 
                    onClose={closeAllEventsAnnouncementHandlerClick}
                    editHandleClick={editHandleClickAnnouncement}
                    deleteHandleClick={deleteHandleClickAnnouncement}
                    isUpdate={isUpdateAnnouncement}
                    setIsUpdate={setIsUpdateAnnouncement}
                    userAccess={userAccess}
            >
            </ViewAllEventsAnnouncementForm>
            <ViewAllEventsMemoForm  isOpen={showAllEventsMemo} 
                    onClose={closeAllEventsMemoHandlerClick}
                    editHandleClick={editHandleClickMemo}
                    deleteHandleClick={deleteHandleClickMemo}
                    isUpdate={isUpdateMemo}
                    setIsUpdate={setIsUpdateMemo}
                    userAccess={userAccess}
            >
            </ViewAllEventsMemoForm>
            <EditAnnouncementForm  isOpen={showEditAnnouncement} 
                    onClose={closeEditAnnouncementFormHandlerClick}
                    description={description}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    contentAnnouncement={contentAnnouncement}
                    files={filesAnnouncement}
                    setDescription={setDescription}
                    setDateFrom={setDateFrom}
                    setDateTo={setDateTo}
                    setContentAnnouncement={setContentAnnouncement}
                    setFiles={setFilesAnnouncement}
                    handleSubmitAnnouncement={handleUpdateAnnouncement}
                    userAccess={userAccess}
            >
            </EditAnnouncementForm>
            <EditMemoForm  isOpen={showEditMemo} 
                    onClose={closeEditMemoFormHandlerClick}
                    description={description}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    contentMemo={contentMemo}
                    files={filesMemo}
                    setDescription={setDescription}
                    setDateFrom={setDateFrom}
                    setDateTo={setDateTo}
                    setContentMemo={setContentMemo}
                    setFiles={setFilesMemo}
                    handleSubmitMemo={handleUpdateMemo}
                    userAccess={userAccess}
            >
            </EditMemoForm>
            <DeleteAnnouncementForm  isOpen={showDeleteAnnouncement} 
                    onClose={closeDeleteAnnouncementFormHandlerClick}
                    handleDelete={handleDeleteAnnouncement}
            >
            </DeleteAnnouncementForm>
            <DeleteMemoForm  isOpen={showDeleteMemo} 
                    onClose={closeDeleteMemoFormHandlerClick}
                    handleDelete={handleDeleteMemo}
            ></DeleteMemoForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "2000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function CalendarHeader({
    todayHandlerClick,
    previousHandlerClick,
    nextHandlerClick,
    addAnnouncementHandlerClick,
    addMemoHandlerClick,
    addGeneralAnnouncementHandlerClick,
    addGeneralMemoHandlerClick,
    userAccess
}){
    return(
        <div>
            <div className='calendar-header row'>
                <div className="calendar-buttons row" style={{width:"50%", justifyContent: "start"}}>
                    <div className="calendar-button row">
                        {CreateButton("", "next-prev row", previousHandlerClick, "<", "")}
                    </div>
                    <div className="calendar-button row">
                        {CreateButton("", "next-prev row", nextHandlerClick, ">", "")}
                    </div>
                    <div className="calendar-button row">
                        {CreateButton("", "current row", todayHandlerClick, "TODAY", "")}
                    </div>
                </div>
                <div className='commandButtons' style={{width:"50%"}}>
                    { userAccess && (userAccess?.description === "Admin" 
                        || userAccess?.description === "HR Head" 
                        || userAccess?.description === "HR Assistant"
                        || userAccess?.description === "HR Assistant2"
                        || userAccess?.description === "HR Assistant3"
                        ) 
                        &&
                        <>
                            <div className="calendar-buttons cmdButton row">
                                <div className="calendar-button row">
                                    {CreateButton("", "command announcement row", addGeneralAnnouncementHandlerClick, "GENERAL ANNOUNCEMENT", AnnouncementIcon)}
                                </div>
                                <div className="calendar-button row">
                                    {CreateButton("", "command memo row", addGeneralMemoHandlerClick, "GENERAL MEMO", StickyNote2Icon)}
                                </div>
                            </div>
                            <div className="calendar-buttons cmdButton row">
                                <div className="calendar-button row">
                                    {CreateButton("", "command announcement row", addAnnouncementHandlerClick, "ANNOUNCEMENT", AddIcon)}
                                </div>
                                <div className="calendar-button row">
                                    {CreateButton("", "command memo row", addMemoHandlerClick, "MEMO", AddIcon)}
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    )
}
function CalendarBody({selectedDate, 
    date, 
    setDate,
    addEventsAnnouncementHandlerClick,
    addEventsMemoHandlerClick,
    isRefreshEvents,
    setIsRefreshEvents,
}) {
    const currentDate = selectedDate;
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    const firstDayOfMonth = new Date(currentYear, currentMonth, 1);
    const firstDayOfWeek = firstDayOfMonth.getDay();
    const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const [calendarGrid, setCalendarGrid] = useState([]);

    const [activeDate, setActiveDate] = useState("");

    const [announcements, setAnnouncements] = useState([]);
    const [memos, setMemos] = useState([]);
    const [loadingRequest, setLoadingRequest] = useState(false);

    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [isToggleOpen, setIsToggleOpen] = useState(false);
    const [toggleDate, setToggleDate] = useState(false);

    const fetchDataAnnouncement = useCallback(async () => {
        const apiUrl =  domain + "/api/Announcement";
        setLoadingRequest(true);

        try {
            const response = await axios.get(`${apiUrl}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            return response.data; // Set the response data to the state
        } catch (error) {
            setLoadingRequest(false);
            console.error('Error fetching data:', error);
            return [];
        } finally {
            setLoadingRequest(false);
        }
    }, []);
    const fetchDataMemo = useCallback(async () => {
        const apiUrl =  domain + "/api/Memo";

        try {
            const response = await axios.get(`${apiUrl}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            return response.data; // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        } finally {
            setIsRefreshEvents(false);
        }
    }, [setIsRefreshEvents]);

    useEffect(() => {
        const fetchDataGeneral = async () => {
            const fetchedAnnouncement = await fetchDataAnnouncement();
            const fetchedMemos = await fetchDataMemo();

            setAnnouncements(fetchedAnnouncement);
            setMemos(fetchedMemos);
        };

        fetchDataGeneral();
    }, [fetchDataAnnouncement, fetchDataMemo, isRefreshEvents]);
    
    function formatDate(dateString) {
        const date = new Date(dateString);
        
        const utcTime = date.getTime() - (date.getTimezoneOffset() * 60000);
        const utcDate = new Date(utcTime);
        
        const year = utcDate.getUTCFullYear();
        const month = String(utcDate.getUTCMonth() + 1).padStart(2, '0');
        const day = String(utcDate.getUTCDate()).padStart(2, '0');
        
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    }
    
    function areDatesEqual(date1, date2) {
        // Create Date objects from the provided date strings or values
        const d1 = new Date(date1);
        const d2 = new Date(date2);
    
        // Compare year, month, and day of the two Date objects
        return (
            d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate()
        );
    }

    const getAnnouncementEvents = useCallback((date) =>{
        let haveEvents = false;
        let length = 0;

        announcements.forEach(announcement => {
            const announcementDateFrom = new Date(announcement.dateFrom);
            const announcementDateTo = new Date(announcement.dateTo);
    
            if (date >= announcementDateFrom && date <= announcementDateTo) {
                haveEvents = true;
                length++;
            }
        });
        
        return { haveEvents, length };
    }, [announcements]);
    const getMemoEvents = useCallback((date) =>{
        let haveEvents = false;
        let length = 0;

        memos.forEach(memo => {
            const memoDateFrom = new Date(memo.dateFrom);
            const memoDateTo = new Date(memo.dateTo);
    
            if (date >= memoDateFrom && date <= memoDateTo) {
                haveEvents = true;
                length++;
            }
        })
        
        return { haveEvents, length };
    }, [memos]);
    
    const handleClick = useCallback((date, divKey) =>{
        setActiveDate(divKey);
        setDate(formatDate(date));
    }, [setDate]);

    const toggleButtonClick = useCallback((date) =>{
        setIsToggleOpen(!isToggleOpen);
        setToggleDate(date);
    }, [isToggleOpen]);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 1500px)');

        // Event listener callback function
        const handleMediaQueryChange = (event) => {
            setIsSmallScreen(event.matches);
        };

        // Initial check
        handleMediaQueryChange(mediaQuery);

        // Add event listener
        mediaQuery.addEventListener('change', handleMediaQueryChange);

        // Cleanup function to remove the event listener
        return () => {
            mediaQuery.removeEventListener('change', handleMediaQueryChange);
        };
    }, []);

    useEffect(() => {
        // console.log("111", announcements)
        const buildCalendarGrid = () => {
            const newCalendarGrid = [];

            // Calculate the dates from the previous month
            const prevMonthLastDate = new Date(currentYear, currentMonth, 0).getDate();
            const prevMonthStartDay = prevMonthLastDate - firstDayOfWeek + 1;

            // Push the dates from the previous month
            for (let i = prevMonthStartDay; i <= prevMonthLastDate; i++) {
                newCalendarGrid.push(
                    <div key={`prev-${i}`} className="calendar-cell prev-month">{`${new Date(currentYear, currentMonth - 1).toLocaleString('default', { month: 'short' })} ${i}`}</div>
                );
            }

            // Push the dates for the current month
            for (let i = 1; i <= daysInMonth; i++) {
                const currentDate = new Date(currentYear, currentMonth, i);
                const classNames = ["calendar-cell", "current-month"];
                if (currentDate.toDateString() === new Date().toDateString()) {
                    classNames.push("current-date");
                }

                newCalendarGrid.push(
                    <div key={`current-${i}`} className={`${classNames.join(" ")} ${activeDate === `current-${i}` ? "activeDate" : ""}`} 
                        onClick={()=>handleClick(new Date(currentYear, currentMonth, i), `current-${i}`)}>
                        <div className='dateHolder'>
                            <div>{i}</div>
                            {(getAnnouncementEvents(currentDate).haveEvents || getMemoEvents(currentDate).haveEvents) &&
                                <div className='eventsHolder'>
                                    { !isSmallScreen ?
                                    <>
                                        {getAnnouncementEvents(currentDate).haveEvents &&
                                            <div className='announcementHolder' onClick={() => addEventsAnnouncementHandlerClick(formatDate(currentDate))}>
                                                <div className='announcementLength'>
                                                    {getAnnouncementEvents(currentDate).length}
                                                </div>
                                                <div>
                                                    {"Announcement"}
                                                </div>
                                            </div>
                                        }
                                        {getMemoEvents(currentDate).haveEvents &&
                                            <div className='memoHolder' onClick={() => addEventsMemoHandlerClick(formatDate(currentDate))}>
                                                <div className='memoLength'>
                                                    {getMemoEvents(currentDate).length}
                                                </div>
                                                <div>
                                                    {"Memo"}
                                                </div>
                                            </div>
                                        }
                                    </>
                                    :
                                    <>
                                        <div className='event-toggleButton' onClick={()=> toggleButtonClick(formatDate(currentDate))}>
                                            <CalendarViewDayIcon style={{width: "20px", height: "20px"}}/>
                                        </div>
                                        { isToggleOpen && (areDatesEqual(toggleDate, formatDate(currentDate))) &&
                                            <div className="events-list">
                                                {getAnnouncementEvents(currentDate).haveEvents &&
                                                    <div className='announcementHolder' onClick={() => addEventsAnnouncementHandlerClick(formatDate(currentDate))}style={{marginBottom: "12px"}}>
                                                        <div className='announcementLength'>
                                                            {getAnnouncementEvents(currentDate).length}
                                                        </div>
                                                        <div>
                                                            {"Announcement"}
                                                        </div>
                                                    </div>
                                                }
                                                {getMemoEvents(currentDate).haveEvents &&
                                                    <div className='memoHolder' onClick={() => addEventsMemoHandlerClick(formatDate(currentDate))}>
                                                        <div className='memoLength'>
                                                            {getMemoEvents(currentDate).length}
                                                        </div>
                                                        <div>
                                                            {"Memo"}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                );
            }

            // Push the dates for the next month
            const totalGridCells = 7 * Math.ceil((daysInMonth + firstDayOfWeek) / 7);
            for (let i = 1; newCalendarGrid.length < totalGridCells; i++) {
                const nextMonthDate = i <= daysInMonth ? i : i - daysInMonth;
                const nextMonth = currentMonth + 1;
                const nextYear = nextMonth === 12 ? currentYear + 1 : currentYear;
                const nextMonthName = nextMonth === 12 ? new Date(nextYear, 0).toLocaleString('default', { month: 'short' }) : new Date(nextYear, nextMonth).toLocaleString('default', { month: 'short' });
                newCalendarGrid.push(
                    <div key={`next-${i}`} className="calendar-cell next-month">{`${nextMonthName} ${nextMonthDate}`}</div>
                );
            }

            setCalendarGrid(newCalendarGrid);
        };

        buildCalendarGrid();
    }, [isSmallScreen, 
        toggleButtonClick, 
        isToggleOpen,
        toggleDate,
        announcements, 
        memos, 
        activeDate, 
        currentMonth, 
        currentYear, 
        daysInMonth, 
        firstDayOfWeek, 
        addEventsAnnouncementHandlerClick, 
        addEventsMemoHandlerClick, 
        handleClick, 
        getAnnouncementEvents, 
        getMemoEvents]);

    return (
        <div>
            <div className="calendar-grid">
                {weekDays.map(day => (
                    <div key={day} className="calendar-cell day-of-week">{day}</div>
                ))}
                {calendarGrid}
            </div>
            {loadingRequest ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}
function MonthYearPicker({selectedDate, setSelectedDate}) {
    const CustomInput = ({ value, onClick }) => (
        <button className="custom-input" onClick={onClick}>
        {value}
        </button>
    );

    return (
        <div>
        <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            dateFormat="MMMM yyyy"
            showMonthYearPicker
            locale="en" // Set the locale to English
            customInput={<CustomInput />}
        />
        </div>
    );
}
function AddGeneralAnnouncementForm({
    isOpen, 
    onClose,
    description, 
    date, 
    contentAnnouncement, 
    files,
    setDescription, 
    setDate, 
    setContentAnnouncement,
    setFiles,
    setOldDescription, 
    setOldContentAnnouncement,
    setOldFiles,
    setGeneralData,
    handleSubmitAnnouncementCreate,
    handleSubmitAnnouncementUpdate,
    handleSubmitGeneralDelete
}) 
{
    const [errorState, setErrorState] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [isCreate, setIsCreate] = useState(false);
    const [showDeleteForm, setShowDeleteForm] = useState(false);

    const submit = (e) =>{
        if(!description
            || !contentAnnouncement
        ){
            setErrorState(true);
            return;
        }
        if(isCreate){
            handleSubmitAnnouncementCreate(e);
        } else {
            handleSubmitAnnouncementUpdate(e);
        }
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setErrorState(false);
        setDescription("");
        setDate("");
        setContentAnnouncement("");
        setFiles("");
        setGeneralData([]);
    };

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/General";

        try {
            setLoadingRequest(true);
            const response = await axios.get(`${apiUrl}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            return response.data
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        } finally {
            setLoadingRequest(false); // Set loading state to false after data fetching is complete
        }
    }, []);

    useEffect(() => {
        const fetchDataGeneral = async () => {
            if (isOpen) {
                const dataGeneral = await fetchData();
                // Handle the fetched data (e.g., update state)
                const foundKey = dataGeneral.find(data => data.key === "Announcement");
                let filesToBeSet = [];

                if(foundKey){
                    setGeneralData(foundKey);
                    setIsCreate(false);
                    setDescription(foundKey.title);
                    setContentAnnouncement(foundKey.description);
                    setOldDescription(foundKey.title);
                    setOldContentAnnouncement(foundKey.description);

                    if(foundKey.content){
                        const binaryData = atob(foundKey.content);
                
                        // Convert the binary data to a Uint8Array
                        const arrayBuffer = new ArrayBuffer(binaryData.length);
                        const uint8Array = new Uint8Array(arrayBuffer);
                        for (let i = 0; i < binaryData.length; i++) {
                            uint8Array[i] = binaryData.charCodeAt(i);
                        }
                
                        const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data
                
                        const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type
                
                        filesToBeSet.push(file);
                    }
                    
                    setFiles(filesToBeSet);
                    setOldFiles(filesToBeSet);
                } else {
                    setIsCreate(true);
                }
            }
        };
        
        fetchDataGeneral();
    }, [fetchData, isOpen, setDescription, setContentAnnouncement, setFiles, setOldDescription, setOldContentAnnouncement, setOldFiles, setGeneralData]);

    // for upload
    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);

        if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setFiles("");
                return;
            }
        }

        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        
        const fileList = Array.from(e.dataTransfer.files);
        e.currentTarget.style.backgroundColor = "white";

        if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setFiles("");
                return;
            }
        }

        setFiles(fileList);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };
    const closeClearForm = () =>{
        setShowDeleteForm(false);
    }
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add General Announcement</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Description</div>
                            <div className="info-item-input">
                                <input
                                id="description"
                                placeholder="Description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !description && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Content</div>
                            <div className="info-item-input">
                                <textarea id="overtime-tamper"
                                        style={{width:"95%",minHeight:"100px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={contentAnnouncement}
                                        onChange={(e) => setContentAnnouncement(e.target.value)}
                                />
                            </div>
                            <span style={{
                                    visibility: !contentAnnouncement && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Upload</div>
                            <div className="info-item-input">
                                <label htmlFor="fileInput" className='browse'>Browse...</label>
                                <input
                                    type="file"
                                    id="fileInput"
                                    onChange={(e)=> handleBrowse(e)}
                                    style={{ display: 'none' }}
                                />
                                
                                {files.length > 0 ? (
                                    <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                        <span>Uploaded File:</span>
                                        <ul>
                                            {files.map((file, index) => (
                                            <img src={file ? URL.createObjectURL(file) : "images/sample.jpg"} alt="" style={{width: "150px", height: "auto"}}></img>
                                            ))}
                                        </ul>
                                        <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                            <button id="add-family" 
                                            className="cancel row"
                                            onClick={()=>clearFiles()}
                                            style={{marginRight:"5px"}}>
                                                CLEAR
                                            </button>
                                        </div>
                                    </div>
                                )
                                :
                                (
                                    <div
                                        id='drop-files-here'
                                        onDrop={(e)=>handleDrop(e)}
                                        onDragOver={(e)=>handleDragOver(e)}
                                        onDragLeave={(e)=>handleDragOut(e)}
                                        style={{
                                        border: '2px dashed #ccc',
                                        borderRadius: '5px',
                                        padding: '20px',
                                        marginTop: '10px',
                                        textAlign: 'center',
                                        }}
                                    >
                                        Drop files here
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>setShowDeleteForm(true)}
                            style={{marginRight:"5px", borderRadius: "3px", height: "34px"}}>
                                CLEAR
                        </button>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>
            <ClearGeneralForm isOpen={showDeleteForm} onClose={closeClearForm} handleDelete={handleSubmitGeneralDelete}/>
            {loadingRequest ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </>
    );
}
function AddGeneralMemoForm({
    isOpen, 
    onClose,
    description, 
    date, 
    contentMemo,
    files,
    setDescription, 
    setDate, 
    setContentMemo,
    setFiles,
    setOldDescription,
    setOldContentMemo,
    setOldFiles,
    setGeneralData,
    handleSubmitMemoCreate,
    handleSubmitMemoUpdate,
    handleSubmitGeneralDelete
}) 
{
    const [errorState, setErrorState] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [isCreate, setIsCreate] = useState(false);
    const [showDeleteForm, setShowDeleteForm] = useState(false);

    const submit = (e) =>{
        if(!description
            || !contentMemo
        ){
            setErrorState(true);
            return;
        }
        if(isCreate){
            handleSubmitMemoCreate(e);
        } else {
            handleSubmitMemoUpdate(e);
        }
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setDescription("");
        setDate("");
        setContentMemo("");
        setFiles("");
        setGeneralData([]);
        setErrorState(false);
    };

    // for upload
    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/General";

        try {
            setLoadingRequest(true);
            const response = await axios.get(`${apiUrl}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            return response.data
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        } finally {
            setLoadingRequest(false); // Set loading state to false after data fetching is complete
        }
    }, []);

    useEffect(() => {
        const fetchDataGeneral = async () => {
            if (isOpen) {
                const dataGeneral = await fetchData();
                // Handle the fetched data (e.g., update state)
                const foundKey = dataGeneral.find(data => data.key === "Memo");
                let filesToBeSet = [];

                if(foundKey){
                    setGeneralData(foundKey);
                    setIsCreate(false);
                    setDescription(foundKey.title);
                    setContentMemo(foundKey.description);
                    setOldDescription(foundKey.title);
                    setOldContentMemo(foundKey.description);

                    if(foundKey.content){
                        const binaryData = atob(foundKey.content);
                
                        // Convert the binary data to a Uint8Array
                        const arrayBuffer = new ArrayBuffer(binaryData.length);
                        const uint8Array = new Uint8Array(arrayBuffer);
                        for (let i = 0; i < binaryData.length; i++) {
                            uint8Array[i] = binaryData.charCodeAt(i);
                        }
                
                        const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data
                
                        const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type
                
                        filesToBeSet.push(file);
                    }
                    
                    setFiles(filesToBeSet)
                    setOldFiles(filesToBeSet)
                } else {
                    setIsCreate(true);
                }
            }
        };
        
        fetchDataGeneral();
    }, [fetchData, isOpen, setDescription, setContentMemo, setFiles, setOldDescription, setOldContentMemo, setOldFiles,setGeneralData]);

    const closeClearForm = () =>{
        setShowDeleteForm(false);
    }
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add General Memo</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Description</div>
                            <div className="info-item-input">
                                <input
                                id="description"
                                placeholder="Description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !description && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Content</div>
                            <div className="info-item-input">
                                <textarea id="overtime-tamper"
                                        style={{width:"95%",minHeight:"100px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={contentMemo}
                                        onChange={(e) => setContentMemo(e.target.value)}
                                />
                            </div>
                            <span style={{
                                    visibility: !contentMemo && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Upload</div>
                            <div className="info-item-input">
                                <label htmlFor="fileInput" className='browse'>Browse...</label>
                                <input
                                    type="file"
                                    id="fileInput"
                                    onChange={(e)=> handleBrowse(e)}
                                    style={{ display: 'none' }}
                                />
                                
                                {files.length > 0 ? (
                                    <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                        <span>Uploaded File:</span>
                                        <ul>
                                            {files.map((file, index) => (
                                            <img src={file ? URL.createObjectURL(file) : "images/sample.jpg"} alt="" style={{width: "150px", height: "auto"}}></img>
                                            ))}
                                        </ul>
                                        <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                            <button id="add-family" 
                                            className="cancel row"
                                            onClick={()=>clearFiles()}
                                            style={{marginRight:"5px"}}>
                                                CLEAR
                                            </button>
                                        </div>
                                    </div>
                                )
                                :
                                (
                                    <div
                                        id='drop-files-here'
                                        onDrop={(e)=>handleDrop(e)}
                                        onDragOver={(e)=>handleDragOver(e)}
                                        onDragLeave={(e)=>handleDragOut(e)}
                                        style={{
                                        border: '2px dashed #ccc',
                                        borderRadius: '5px',
                                        padding: '20px',
                                        marginTop: '10px',
                                        textAlign: 'center',
                                        }}
                                    >
                                        Drop files here
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>setShowDeleteForm(true)}
                            style={{marginRight:"5px", borderRadius: "3px", height: "34px"}}>
                                CLEAR
                        </button>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>
            <ClearGeneralForm isOpen={showDeleteForm} onClose={closeClearForm} handleDelete={handleSubmitGeneralDelete}/>
            {loadingRequest ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </>
    );
}
function AddAnnouncementForm({
    isOpen, 
    onClose,
    description, 
    dateFrom, 
    dateTo, 
    contentAnnouncement, 
    files,
    setDescription, 
    setDateFrom, 
    setDateTo, 
    setContentAnnouncement,
    setFiles,
    handleSubmitAnnouncement}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!description
            || !dateFrom
            || !dateTo
            || !contentAnnouncement
        ){
            setErrorState(true);
            return;
        }
        handleSubmitAnnouncement(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setDescription("");
        setDateFrom("");
        setDateTo("");
        setContentAnnouncement("");
        setFiles("");
        setErrorState(false);
    };

    // for upload
    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);

        if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setFiles("");
                return;
            }
        }

        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        
        const fileList = Array.from(e.dataTransfer.files);
        e.currentTarget.style.backgroundColor = "white";

        if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setFiles("");
                return;
            }
        }

        setFiles(fileList);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Announcement</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Description</div>
                            <div className="info-item-input">
                                <input
                                id="description"
                                placeholder="Description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !description && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date From</div>
                            <div className="info-item-input">
                                <DateTimeInput date={dateFrom} setDate={setDateFrom}/>
                            </div>
                            <span style={{
                                    visibility: !dateFrom && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date To</div>
                            <div className="info-item-input">
                                <DateTimeInput date={dateTo} setDate={setDateTo}/>
                            </div>
                            <span style={{
                                    visibility: !dateTo && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Content</div>
                            <div className="info-item-input">
                                <textarea id="overtime-tamper"
                                        style={{width:"95%",minHeight:"100px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={contentAnnouncement}
                                        onChange={(e) => setContentAnnouncement(e.target.value)}
                                />
                            </div>
                            <span style={{
                                    visibility: !contentAnnouncement && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Upload</div>
                            <div className="info-item-input">
                                <label htmlFor="fileInput" className='browse'>Browse...</label>
                                <input
                                    type="file"
                                    id="fileInput"
                                    onChange={(e)=> handleBrowse(e)}
                                    style={{ display: 'none' }}
                                />
                                
                                {files.length > 0 ? (
                                    <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                        <span>Uploaded File:</span>
                                        <ul>
                                            {files.map((file, index) => (
                                            <img src={file ? URL.createObjectURL(file) : "images/sample.jpg"} alt="" style={{width: "150px", height: "auto"}}></img>
                                            ))}
                                        </ul>
                                        <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                            <button id="add-family" 
                                            className="cancel row"
                                            onClick={()=>clearFiles()}
                                            style={{marginRight:"5px"}}>
                                                CLEAR
                                            </button>
                                        </div>
                                    </div>
                                )
                                :
                                (
                                    <div
                                        id='drop-files-here'
                                        onDrop={(e)=>handleDrop(e)}
                                        onDragOver={(e)=>handleDragOver(e)}
                                        onDragLeave={(e)=>handleDragOut(e)}
                                        style={{
                                        border: '2px dashed #ccc',
                                        borderRadius: '5px',
                                        padding: '20px',
                                        marginTop: '10px',
                                        textAlign: 'center',
                                        }}
                                    >
                                        Drop files here
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function AddMemoForm({
    isOpen, 
    onClose,
    description, 
    dateFrom, 
    dateTo, 
    contentMemo,
    files,
    setDescription, 
    setDateFrom, 
    setDateTo, 
    setContentMemo,
    setFiles,
    handleSubmitMemo}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!description
            || !dateFrom
            || !dateTo
            || !contentMemo
        ){
            setErrorState(true);
            return;
        }
        handleSubmitMemo(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setDescription("");
        setDateFrom("");
        setDateTo("");
        setContentMemo("");
        setFiles("");
        setErrorState(false);
    };

    // for upload
    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Memo</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Description</div>
                            <div className="info-item-input">
                                <input
                                id="description"
                                placeholder="Description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !description && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date From</div>
                            <div className="info-item-input">
                                <DateTimeInput date={dateFrom} setDate={setDateFrom}/>
                            </div>
                            <span style={{
                                    visibility: !dateFrom && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date To</div>
                            <div className="info-item-input">
                                <DateTimeInput date={dateTo} setDate={setDateTo}/>
                            </div>
                            <span style={{
                                    visibility: !dateTo && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Content</div>
                            <div className="info-item-input">
                                <textarea id="overtime-tamper"
                                        style={{width:"95%",minHeight:"100px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={contentMemo}
                                        onChange={(e) => setContentMemo(e.target.value)}
                                />
                            </div>
                            <span style={{
                                    visibility: !contentMemo && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Upload</div>
                            <div className="info-item-input">
                                <label htmlFor="fileInput" className='browse'>Browse...</label>
                                <input
                                    type="file"
                                    id="fileInput"
                                    onChange={(e)=> handleBrowse(e)}
                                    style={{ display: 'none' }}
                                />
                                
                                {files.length > 0 ? (
                                    <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                        <span>Uploaded File:</span>
                                        <ul>
                                            {files.map((file, index) => (
                                            <img src={file ? URL.createObjectURL(file) : "images/sample.jpg"} alt="" style={{width: "150px", height: "auto"}}></img>
                                            ))}
                                        </ul>
                                        <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                            <button id="add-family" 
                                            className="cancel row"
                                            onClick={()=>clearFiles()}
                                            style={{marginRight:"5px"}}>
                                                CLEAR
                                            </button>
                                        </div>
                                    </div>
                                )
                                :
                                (
                                    <div
                                        id='drop-files-here'
                                        onDrop={(e)=>handleDrop(e)}
                                        onDragOver={(e)=>handleDragOver(e)}
                                        onDragLeave={(e)=>handleDragOut(e)}
                                        style={{
                                        border: '2px dashed #ccc',
                                        borderRadius: '5px',
                                        padding: '20px',
                                        marginTop: '10px',
                                        textAlign: 'center',
                                        }}
                                    >
                                        Drop files here
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditAnnouncementForm({
    isOpen, 
    onClose,
    description, 
    dateFrom, 
    dateTo, 
    contentAnnouncement, 
    files,
    setDescription, 
    setDateFrom, 
    setDateTo, 
    setContentAnnouncement,
    setFiles,
    handleSubmitAnnouncement}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!description
            || !dateFrom
            || !dateTo
            || !contentAnnouncement
        ){
            setErrorState(true);
            return;
        }
        handleSubmitAnnouncement(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setDescription("");
        setDateFrom("");
        setDateTo("");
        setContentAnnouncement("");
        setFiles("");
        setErrorState(false);
    };

    // for upload
    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);

        if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setFiles("");
                return;
            }
        }

        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        
        const fileList = Array.from(e.dataTransfer.files);
        e.currentTarget.style.backgroundColor = "white";

        if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setFiles("");
                return;
            }
        }

        setFiles(fileList);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Edit Announcement</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Description</div>
                            <div className="info-item-input">
                                <input
                                id="description"
                                placeholder="Description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !description && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date From</div>
                            <div className="info-item-input">
                                <DateTimeInput date={dateFrom} setDate={setDateFrom}/>
                            </div>
                            <span style={{
                                    visibility: !dateFrom && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date To</div>
                            <div className="info-item-input">
                                <DateTimeInput date={dateTo} setDate={setDateTo}/>
                            </div>
                            <span style={{
                                    visibility: !dateTo && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Content</div>
                            <div className="info-item-input">
                                <textarea id="overtime-tamper"
                                        style={{width:"95%",minHeight:"100px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={contentAnnouncement}
                                        onChange={(e) => setContentAnnouncement(e.target.value)}
                                />
                            </div>
                            <span style={{
                                    visibility: !contentAnnouncement && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Upload</div>
                            <div className="info-item-input">
                                <label htmlFor="fileInput" className='browse'>Browse...</label>
                                <input
                                    type="file"
                                    id="fileInput"
                                    onChange={(e)=> handleBrowse(e)}
                                    style={{ display: 'none' }}
                                />
                                
                                {files.length > 0 ? (
                                    <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                        <span>Uploaded File:</span>
                                        <ul>
                                            {files.map((file, index) => (
                                            <img src={file ? URL.createObjectURL(file) : "images/sample.jpg"} alt="" style={{width: "150px", height: "auto"}}></img>
                                            ))}
                                        </ul>
                                        <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                            <button id="add-family" 
                                            className="cancel row"
                                            onClick={()=>clearFiles()}
                                            style={{marginRight:"5px"}}>
                                                CLEAR
                                            </button>
                                        </div>
                                    </div>
                                )
                                :
                                (
                                    <div
                                        id='drop-files-here'
                                        onDrop={(e)=>handleDrop(e)}
                                        onDragOver={(e)=>handleDragOver(e)}
                                        onDragLeave={(e)=>handleDragOut(e)}
                                        style={{
                                        border: '2px dashed #ccc',
                                        borderRadius: '5px',
                                        padding: '20px',
                                        marginTop: '10px',
                                        textAlign: 'center',
                                        }}
                                    >
                                        Drop files here
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditMemoForm({
    isOpen, 
    onClose,
    description, 
    dateFrom, 
    dateTo, 
    contentMemo,
    files,
    setDescription, 
    setDateFrom, 
    setDateTo, 
    setContentMemo,
    setFiles,
    handleSubmitMemo}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!description
            || !dateFrom
            || !dateTo
            || !contentMemo
        ){
            setErrorState(true);
            return;
        }
        handleSubmitMemo(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setDescription("");
        setDateFrom("");
        setDateTo("");
        setContentMemo("");
        setFiles("");
        setErrorState(false);
    };

    // for upload
    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Edit Memo</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Description</div>
                            <div className="info-item-input">
                                <input
                                id="description"
                                placeholder="Description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !description && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date From</div>
                            <div className="info-item-input">
                                <DateTimeInput date={dateFrom} setDate={setDateFrom}/>
                            </div>
                            <span style={{
                                    visibility: !dateFrom && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date To</div>
                            <div className="info-item-input">
                                <DateTimeInput date={dateTo} setDate={setDateTo}/>
                            </div>
                            <span style={{
                                    visibility: !dateTo && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Content</div>
                            <div className="info-item-input">
                                <textarea id="overtime-tamper"
                                        style={{width:"95%",minHeight:"100px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={contentMemo}
                                        onChange={(e) => setContentMemo(e.target.value)}
                                />
                            </div>
                            <span style={{
                                    visibility: !contentMemo && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Upload</div>
                            <div className="info-item-input">
                                <label htmlFor="fileInput" className='browse'>Browse...</label>
                                <input
                                    type="file"
                                    id="fileInput"
                                    onChange={(e)=> handleBrowse(e)}
                                    style={{ display: 'none' }}
                                />
                                
                                {files.length > 0 ? (
                                    <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                        <span>Uploaded File:</span>
                                        <ul>
                                            {files.map((file, index) => (
                                            <img src={file ? URL.createObjectURL(file) : "images/sample.jpg"} alt="" style={{width: "150px", height: "auto"}}></img>
                                            ))}
                                        </ul>
                                        <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                            <button id="add-family" 
                                            className="cancel row"
                                            onClick={()=>clearFiles()}
                                            style={{marginRight:"5px"}}>
                                                CLEAR
                                            </button>
                                        </div>
                                    </div>
                                )
                                :
                                (
                                    <div
                                        id='drop-files-here'
                                        onDrop={(e)=>handleDrop(e)}
                                        onDragOver={(e)=>handleDragOver(e)}
                                        onDragLeave={(e)=>handleDragOut(e)}
                                        style={{
                                        border: '2px dashed #ccc',
                                        borderRadius: '5px',
                                        padding: '20px',
                                        marginTop: '10px',
                                        textAlign: 'center',
                                        }}
                                    >
                                        Drop files here
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DateTimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    let formattedDate = "";

    if(date){
        formattedDate = date.split('T')[0];
    }

    return (
        <div>
            <input
            type="date"
            id={"datetime-"}
            name="datetime"
            value={formattedDate}
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function ViewAllEventsAnnouncementForm({isOpen, 
    onClose,
    editHandleClick,
    deleteHandleClick,
    isUpdate,
    setIsUpdate,
    userAccess
}){
    var header = [
        "Description",
        "Date From",
        "Date To",
        "Content",
        "Image",
        "",
    ]
    var accessor = [
        "title",
        "dateFrom",
        "dateTo",
        "description",
        "content",
        "manage"
    ]

    if(userAccess){
        if(userAccess?.description !== "Admin" 
            && userAccess?.description !== "HR Head" 
            && userAccess?.description !== "HR Assistant"
            && userAccess?.description !== "HR Assistant2"
            && userAccess?.description !== "HR Assistant3"
            ) {
            header = [
                "Description",
                "Date From",
                "Date To",
                "Content",
                "Image",
            ];

            accessor = [
                "title",
                "dateFrom",
                "dateTo",
                "description",
                "content",
            ]
        }
    }

    const [loading, setLoading] = useState(false);
    const [requests, setRequests] = useState(false);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/Announcement";

        try {
            setLoading(true);
            const response = await axios.get(`${apiUrl}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            setRequests(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
            setIsUpdate(false);
        }
    }, [setIsUpdate]);

    useEffect(() => {
        if(isOpen){
            fetchData();
        }
    }, [fetchData, isOpen, isUpdate]);

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Announcement/s</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTable
                                dataList={requests ? requests : []}
                                dataHeader={header}
                                dataAccessor={accessor}
                                editHandleClick={editHandleClick}
                                deleteHandleClick={deleteHandleClick}
                            />
                            {requests.length > 0 ? (
                                <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ViewAllEventsMemoForm({isOpen, 
    onClose,
    editHandleClick,
    deleteHandleClick,
    isUpdate,
    setIsUpdate,
    userAccess
}){
    var header = [
        "Description",
        "Date From",
        "Date To",
        "Content",
        "Image",
        ""
    ]
    var accessor = [
        "title",
        "dateFrom",
        "dateTo",
        "description",
        "content",
        "manage"
    ]

    if(userAccess){
        if(userAccess?.description !== "Admin" 
            && userAccess?.description !== "HR Head" 
            && userAccess?.description !== "HR Assistant"
            && userAccess?.description !== "HR Assistant2"
            && userAccess?.description !== "HR Assistant3"
            ) {
            header = [
                "Description",
                "Date From",
                "Date To",
                "Content",
                "Image",
            ];

            accessor = [
                "title",
                "dateFrom",
                "dateTo",
                "description",
                "content",
            ]
        }
    }

    const [loading, setLoading] = useState(false);
    const [requests, setRequests] = useState(false);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/Memo";

        try {
            setLoading(true);
            const response = await axios.get(`${apiUrl}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            setRequests(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
            setIsUpdate(false);
        }
    }, [setIsUpdate]);

    useEffect(() => {
        if(isOpen){
            fetchData();
        }
    }, [fetchData, isOpen, isUpdate]);

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Memo/s</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTable
                                dataList={requests ? requests : []}
                                dataHeader={header}
                                dataAccessor={accessor}
                                editHandleClick={editHandleClick}
                                deleteHandleClick={deleteHandleClick}
                            />
                            {requests.length > 0 ? (
                                <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ViewEventsAnnouncementForm({isOpen, 
    onClose,
    eventDate,
    editHandleClick,
    deleteHandleClick,
    isUpdate,
    setIsUpdate,
    userAccess
}){
    var header = [
        "Description",
        "Date From",
        "Date To",
        "Content",
        "Image",
        "",
    ]
    var accessor = [
        "title",
        "dateFrom",
        "dateTo",
        "description",
        "content",
        "manage"
    ]

    if(userAccess){
        if(userAccess?.description !== "Admin" 
            && userAccess?.description !== "HR Head" 
            && userAccess?.description !== "HR Assistant"
            && userAccess?.description !== "HR Assistant2"
            && userAccess?.description !== "HR Assistant3"
            ) {
            header = [
                "Description",
                "Date From",
                "Date To",
                "Content",
                "Image",
            ];

            accessor = [
                "title",
                "dateFrom",
                "dateTo",
                "description",
                "content",
            ]
        }
    }

    const [loading, setLoading] = useState(false);
    const [requests, setRequests] = useState(false);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/Announcement";

        try {
            setLoading(true);
            const response = await axios.get(`${apiUrl}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            let filteredData = [];
            response.data.forEach(announcement => {
                const announcementDateFrom = new Date(announcement.dateFrom);
                const announcementDateTo = new Date(announcement.dateTo);
                const thisDate = new Date();
    
                // Strip time component by setting to midnight
                const thisDateOnly = new Date(thisDate.setHours(0, 0, 0, 0));
                const announcementDateFromOnly = new Date(announcementDateFrom.setHours(0, 0, 0, 0));
                const announcementDateToOnly = new Date(announcementDateTo.setHours(23, 59, 59, 999));
    
                if (thisDateOnly >= announcementDateFromOnly && thisDateOnly <= announcementDateToOnly) {
                    filteredData.push(announcement);
                }
            });

            setRequests(filteredData); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
            setIsUpdate(false);
        }
    }, [setIsUpdate]);

    useEffect(() => {
        if(isOpen){
            fetchData();
        }
    }, [fetchData, isOpen, isUpdate]);

    const handleClose = () => {
        setRequests([]);
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Announcement/s</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTable
                                dataList={requests ? requests : []}
                                dataHeader={header}
                                dataAccessor={accessor}
                                editHandleClick={editHandleClick}
                                deleteHandleClick={deleteHandleClick}
                            />
                            {requests.length > 0 ? (
                                <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ViewEventsMemoForm({isOpen, 
    onClose,
    eventDate,
    editHandleClick,
    deleteHandleClick,
    isUpdate,
    setIsUpdate,
    userAccess
}){
    var header = [
        "Description",
        "Date From",
        "Date To",
        "Content",
        "Image",
        "",
    ]
    var accessor = [
        "title",
        "dateFrom",
        "dateTo",
        "description",
        "content",
        "manage"
    ]

    if(userAccess){
        if(userAccess?.description !== "Admin" 
            && userAccess?.description !== "HR Head" 
            && userAccess?.description !== "HR Assistant"
            && userAccess?.description !== "HR Assistant2"
            && userAccess?.description !== "HR Assistant3"
            ) {
            header = [
                "Description",
                "Date From",
                "Date To",
                "Content",
                "Image",
            ];

            accessor = [
                "title",
                "dateFrom",
                "dateTo",
                "description",
                "content",
            ]
        }
    }

    const [loading, setLoading] = useState(false);
    const [requests, setRequests] = useState(false);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/Memo";

        try {
            setLoading(true);
            const response = await axios.get(`${apiUrl}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            let filteredData = [];
            response.data.forEach(memo => {
                const memoDateFrom = new Date(memo.dateFrom);
                const memoDateTo = new Date(memo.dateTo);
                const thisDate = new Date();
    
                // Strip time component by setting to midnight
                const thisDateOnly = new Date(thisDate.setHours(0, 0, 0, 0));
                const memoDateFromOnly = new Date(memoDateFrom.setHours(0, 0, 0, 0));
                const memoDateToOnly = new Date(memoDateTo.setHours(23, 59, 59, 999));
    
                if (thisDateOnly >= memoDateFromOnly && thisDateOnly <= memoDateToOnly) {
                    filteredData.push(memo);
                }
            });

            setRequests(filteredData); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
            setIsUpdate(false);
        }
    }, [setIsUpdate]);

    useEffect(() => {
        if(isOpen){
            fetchData();
        }
    }, [fetchData, isOpen, isUpdate]);

    const handleClose = () => {
        onClose();
        setRequests([]);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Memo/s</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTable
                                dataList={requests ? requests : []}
                                dataHeader={header}
                                dataAccessor={accessor}
                                editHandleClick={editHandleClick}
                                deleteHandleClick={deleteHandleClick}
                            />
                            {requests.length > 0 ? (
                                <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DeleteAnnouncementForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to delete this announcement?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleDelete}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DeleteMemoForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to delete this memo?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleDelete}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ClearGeneralForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Clear!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to clear this?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>{handleDelete(e); handleClose()}}
                            style={{marginRight:"5px"}}>
                                CLEAR
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
export function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], editHandleClick, deleteHandleClick }) {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    SetInfo(cell.render("Cell").props.column.Header, 
                                            cell,
                                            editHandleClick,
                                            deleteHandleClick)
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </>
            ) :
            <></>}
        </>
    )
}
function SetInfo(header, _cell, editHandleClick, deleteHandleClick) {
    const data = _cell.render("Cell").props.row.original;
    // const value = _cell.render("Cell").props.value;

    if (header === "") {
        return(
            <td>
                <div className="calendarManage row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if (header === "Image") {
        if(data.content){
            const imageSrc = 'data:image/jpeg;base64,' + data.content;

            return(
                <td>
                    <img className="" src={imageSrc} alt="" style={{width: "250px", height: "auto"}}/>
                </td>
            )
        }
        return(
            <td>
                <img className="" src="" alt=""/>
            </td>
        )
    }
    
    if(header === "Date" 
        || header === "Date From"
        || header === "Date To"
    ){
        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
export default Calendar
